export const formatINR = (amount: number | string | null | undefined, fallback = "—"): string => {
  const numericAmount = typeof amount === "string" ? Number(amount) : amount;
  if (numericAmount === null || numericAmount === undefined || !Number.isFinite(numericAmount)) {
    return fallback;
  }
  return `₹${numericAmount.toLocaleString("en-IN")}`;
};

const LAKH = 100000;
const CRORE = 10000000;

// Drops trailing zeros left by `toFixed(2)` — "5.00" -> "5", "12.30" -> "12.3".
const trimTrailingZeros = (value: number) => value.toFixed(2).replace(/\.?0+$/, "");

// Indian-numbering compact form for large figures — e.g. a stat card where
// "₹1,23,45,678" would crowd the layout. Below 1 lakh, falls back to
// `formatINR`'s plain grouped form; above that, suffixes "L" (lakh, 10^5)
// or "Cr" (crore, 10^7) per the user.
export const formatINRCompact = (amount: number | string | null | undefined, fallback = "—"): string => {
  const numericAmount = typeof amount === "string" ? Number(amount) : amount;
  if (numericAmount === null || numericAmount === undefined || !Number.isFinite(numericAmount)) {
    return fallback;
  }
  const abs = Math.abs(numericAmount);
  if (abs >= CRORE) return `₹${trimTrailingZeros(numericAmount / CRORE)}Cr`;
  if (abs >= LAKH) return `₹${trimTrailingZeros(numericAmount / LAKH)}L`;
  return formatINR(numericAmount, fallback);
};
